import { Component, Input } from '@angular/core';
import { TEMPLATE_GUIDE } from '../../interfaces/user.interface';

@Component({
    selector: 'com-template-info',
    templateUrl: './template-info.component.html',
    styleUrls: ['./template-info.component.scss'],
})
export class TemplateInfoComponent {
    @Input() templateFields: TEMPLATE_GUIDE[] = [];
}
